import { request } from './http';
import { config } from './config';
import type { DiscountData, LatLon } from '../domain/types';

type DiscountEnvelope = {
  data?: {
    discountType?: number;
    discount?: Record<string, number>;
    maxValues?: Record<string, number>;
    validUntil?: string | null;
  } | null;
};

// POST {rpcBaseUrl}/get-discount-by-phone-number-and-origin-point — the user's
// active discount (referral/promo). Same host flutter_client's _apiCoreRPC uses.
// Returns null when the user has no discount so callers can render prices as-is.
export async function getUserDiscount(
  phone: string,
  point: LatLon,
): Promise<DiscountData | null> {
  try {
    const res = await request<DiscountEnvelope>('/get-discount-by-phone-number-and-origin-point', {
      method: 'POST',
      baseUrl: config.rpcBaseUrl,
      auth: false,
      body: {
        phoneNumber: phone,
        point: { lat: point.lat, lon: point.lon },
      },
    });

    const d = res.data;
    if (!d) return null;
    return {
      discountType: d.discountType ?? 0,
      discount: d.discount ?? {},
      maxValues: d.maxValues ?? {},
      validUntil: d.validUntil ?? null,
    };
  } catch {
    // Best-effort: pricing still works without the user discount.
    return null;
  }
}
